export const AgreementIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2C3.567 2 2 3.567 2 5.5C2 7.433 3.567 9 5.5 9C7.433 9 9 7.433 9 5.5C9 3.567 7.433 2 5.5 2ZM4 5.5C4 4.67157 4.67157 4 5.5 4C6.32843 4 7 4.67157 7 5.5C7 6.32843 6.32843 7 5.5 7C4.67157 7 4 6.32843 4 5.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 2C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9C16.567 9 15 7.433 15 5.5C15 3.567 16.567 2 18.5 2ZM20 5.5C20 4.67157 19.3284 4 18.5 4C17.6716 4 17 4.67157 17 5.5C17 6.32843 17.6716 7 18.5 7C19.3284 7 20 6.32843 20 5.5Z"
        fill="currentColor"
      />
      <path
        d="M4.14461 12.5196C3.80821 12.856 3.5 13.4552 3.5 14.5V20H7V16.5C7 15.9477 7.44772 15.5 8 15.5C8.55228 15.5 9 15.9477 9 16.5V21C9 21.5523 8.55228 22 8 22H2.5C1.94772 22 1.5 21.5523 1.5 21V14.5C1.5 13.0448 1.94179 11.894 2.73039 11.1054C3.51134 10.3244 4.53196 10 5.5 10C6.43345 10 7.16914 10.2387 7.76774 10.6566C8.32951 11.0488 8.73359 11.5933 9.11793 12.1501C9.668 12.9481 9.96035 13.3723 10.6961 13.5194C11.2377 13.6277 11.5889 14.1546 11.4806 14.6961C11.3723 15.2377 10.8454 15.5889 10.3039 15.4806C8.73713 15.1672 8.00126 14.0744 7.50301 13.3344C7.15775 12.8217 6.92113 12.5047 6.62289 12.2965C6.39336 12.1363 6.06655 12 5.5 12C4.96804 12 4.48866 12.1756 4.14461 12.5196Z"
        fill="currentColor"
      />
      <path
        d="M20.5 14.5C20.5 13.4552 20.1918 12.856 19.8554 12.5196C19.5113 12.1756 19.032 12 18.5 12C17.9334 12 17.6066 12.1363 17.3771 12.2965C17.0788 12.5048 16.8424 12.8214 16.497 13.3344C15.9988 14.0744 15.2629 15.1672 13.6961 15.4806C13.1546 15.5889 12.6277 15.2377 12.5194 14.6961C12.4111 14.1546 12.7623 13.6277 13.3039 13.5194C14.0396 13.3723 14.332 12.9481 14.8821 12.1501C15.2664 11.5933 15.6705 11.0488 16.2323 10.6566C16.8309 10.2387 17.5666 10 18.5 10C19.468 10 20.4887 10.3244 21.2696 11.1054C22.0582 11.894 22.5 13.0448 22.5 14.5V21C22.5 21.5523 22.0523 22 21.5 22H16C15.4477 22 15 21.5523 15 21V16.5C15 15.9477 15.4477 15.5 16 15.5C16.5523 15.5 17 15.9477 17 16.5V20H20.5V14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
